<style scoped>

  #open-quotations-segment {
    min-height: 510px !important;
  }

  #chart-container {
    height: 400px !important;
  }

  #info-label {
    margin-top: 150px !important;
  }

</style>

<template>
  
  <div id="open-quotations-segment" class="ui center aligned segment" :class="{ loading }">
    <div class="ui grid">
      <div class="eight wide column">
        <div class="ui basic left aligned segment no-margin no-padding">
          <h4 class="ui header no-margin no-padding">Orçamentos em aberto</h4>
          <div class="grey text" style="font-size: 12px;">
            {{ lastUpdateMessage }}
          </div>
        </div>
      </div>
      <div class="eight wide column">
        <div class="ui basic right aligned segment no-margin no-padding">
          <i class="refresh icon clickable" @click="updateChart({ force: true })"></i>
        </div>
      </div>
    </div>
    <div v-show="status.length > 0" class="ui grid">
      <div id="chart-container" class="eight wide column m-t-20">
        <canvas id="open-quotations-chart"></canvas>
      </div>
      <div class="eight wide column m-t-20">
        <div class="ui basic segment no-padding no-margin left aligned">
          <div class="ui mini labels">
            <a v-for="item in status" :class="'ui label ' + item.color">
              <i :class="'icon m-r-5 ' + item.icon"></i>
              {{ item.description }}
              <div class="detail">R$ {{ formatValue(item.value) }}</div>
            </a>          
          </div>
        </div>        
      </div>
    </div>
    <h3 id="info-label" v-if="!loading && status.length == 0" class="ui center aligned icon grey text header">
      <span v-if="error">
        <i class="exclamation circle red icon animated flash"></i>
        Falha de comunicação
      </span>
      <span v-else>
        <i class="info circle icon"></i>
        Nenhum orçamento em aberto
      </span>
    </h3>
  </div>

</template>

<script>

  import { DashboardService, QuotationService } from "@/services"
  import { moment, numeral } from "@/utils"

  export default {

    data() {
      return {
        loading: true,
        error: false,
        chart: null,
        status: [],
        lastUpdateMessage: "",
        setIntervalId: null,
      }
    },
   
    mounted() {

      this.setIntervalId = setInterval(this.updateLastUpdateMessage, 60000)

      this.updateChart()
    },

    beforeDestroy() {
      clearInterval(this.setIntervalId)
    },

    methods: {

      async updateChart(data) {

        let forceUpdate = (data && data.force)

        this.loading = true
        this.error = false

        try {

          if (!this.chart)
            this.chart = new Chart($("#open-quotations-chart"), { type: "pie"} )

          let labels = []
          let bgColors = []
          let values = []
          
          if (!forceUpdate && this.$store.state.openQuotationsChartData) {
            this.status = this.$store.state.openQuotationsChartData.status
          } else {
            this.status = await DashboardService.getQuotationStatus()
            this.$store.commit("setOpenQuotationsChartData", { status: this.status, lastUpdate: new Date() })
          }          

          this.status.forEach((status) => {
            labels.push("  " + status.description)
            bgColors.push(status.rgb)
            values.push(status.quantity)
          })

          this.chart.data = {
            labels,
            datasets: [{
              backgroundColor: bgColors,
              data: values,
            }]
          }

          this.chart.options = {
            maintainAspectRatio: false,  
            responsive: true,          
            legend: { display: false },                      
          }

          this.chart.update()

          this.loading = false

          this.updateLastUpdateMessage()
          
        } catch (error) {

          this.loading = false
          this.error = true
          this.status = []

          this.updateLastUpdateMessage()
          
          this.$errorHandler(error, { silent: true })
        }
      },

      formatValue(value) {
        return numeral(value).format("(0.00 a)")
      },

      updateLastUpdateMessage() {

        if (this.$store.state.openQuotationsChartData) {          
          this.lastUpdateMessage = "Atualizado " + moment(this.$store.state.openQuotationsChartData.lastUpdate).fromNow() 
        } else {
          this.lastUpdateMessage = ""
        }   
      },
    },
    
  }
</script>
